import React, { useState } from "react";
import { ChevronDown } from "lucide-react";

const Faq = ({ items, testId = "faq" }) => {
  const [open, setOpen] = useState(null);
  return (
    <div className="divide-y divide-border card-premium" data-testid={testId}>
      {items.map((f, i) => (
        <div key={i}>
          <button
            onClick={() => setOpen(open === i ? null : i)}
            className="w-full flex items-center justify-between gap-4 text-left px-6 py-5 hover:bg-muted/30 transition-colors"
            aria-expanded={open === i}
            data-testid={`${testId}-item-${i}`}
          >
            <span className="font-semibold text-base">{f.q}</span>
            <ChevronDown className={`h-4 w-4 shrink-0 transition-transform ${open === i ? "rotate-180" : ""}`} />
          </button>
          {open === i && (
            <div className="px-6 pb-5 text-sm text-foreground/80 leading-relaxed whitespace-pre-line">
              {f.a}
            </div>
          )}
        </div>
      ))}
    </div>
  );
};

// Helper: build FAQPage JSON-LD from the same items
export const faqJsonLd = (items) => ({
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: items.map((f) => ({
    "@type": "Question",
    name: f.q,
    acceptedAnswer: { "@type": "Answer", text: f.a },
  })),
});

export default Faq;
